// Frontend error codes for non-API errors (Expand as needed. They won't have translations to be aligned with backend error codes)
export const FRONTEND_ERROR_CODES = {
  DOWNLOAD_FAILED: "download_error",
  UPLOAD_FAILED: "upload_error",
  FILE_TOO_LARGE: "file_too_large",
  INVALID_FILE_TYPE: "invalid_file_type",
  DATA_PROCESSING_FAILED: "data_processing_error",
  IMAGE_CROPPING_FAILED: "image_cropping_error",
  EXPORT_FAILED: "export_error",
  IMPORT_FAILED: "import_error",
  UNKNOWN_ERROR: "unknown_error",
  TOO_MANY_ATTEMPTS: "too_many_attempts",
  PENDING_COOKIE_ERROR: "pending_cookie_error",
} as const;

// User friendly messages for frontend error codes
export const FRONTEND_ERROR_MESSAGES = {
  [FRONTEND_ERROR_CODES.DOWNLOAD_FAILED]: "Failed to download the file. Please try again.",
  [FRONTEND_ERROR_CODES.UPLOAD_FAILED]:
    "Failed to upload the file. Please check your connection and try again.",
  [FRONTEND_ERROR_CODES.FILE_TOO_LARGE]: "File is too large. Please select a smaller file.",
  [FRONTEND_ERROR_CODES.INVALID_FILE_TYPE]:
    "Invalid file type. Please select a supported file format.",
  [FRONTEND_ERROR_CODES.IMAGE_CROPPING_FAILED]: "Failed to crop the image. Please try again.",
  [FRONTEND_ERROR_CODES.DATA_PROCESSING_FAILED]: "Failed to process the data. Please try again.",
  [FRONTEND_ERROR_CODES.EXPORT_FAILED]: "Failed to export data. Please try again.",
  [FRONTEND_ERROR_CODES.IMPORT_FAILED]: "Failed to import data. Please check the file format.",
  [FRONTEND_ERROR_CODES.UNKNOWN_ERROR]: "An unexpected error occurred. Please try again.",
  [FRONTEND_ERROR_CODES.TOO_MANY_ATTEMPTS]: "Too many attempts. Please try again later.",
  [FRONTEND_ERROR_CODES.PENDING_COOKIE_ERROR]: "Pending action cookie could not be processed.",
} as const;

export type FrontendErrorCode = (typeof FRONTEND_ERROR_CODES)[keyof typeof FRONTEND_ERROR_CODES];

export const API_ERROR_FALLBACKS = {
  AUTH: {
    LOGIN: "Login failed. Please try again.",
    REGISTER: "Signup failed. Please try again.",
    GOOGLE: "Google authentication failed. Please try again.",
    GOOGLE_LOGIN: "An error occurred during Google login.",
    GOOGLE_SIGNUP: "An error occurred during Google signup.",
    APPLE: "Apple authentication failed. Please try again.",
    APPLE_LOGIN: "An error occurred during Apple login.",
    APPLE_SIGNUP: "An error occurred during Apple signup.",
    PROFILE_SYNC: "Failed to sync user profile.",
    SET_PASSWORD: "Failed to set password. Please try again.",
  },
  QR_EDITOR: {
    SAVE_PROGRESS: "Failed to save progress. Please try again.",
    PREVIEW: "Failed to generate QR preview.",
    LOAD_DATA: "Failed to load QR code data.",
    SAVE_QR_DATA: "Error saving QR data.",
  },
  BILLING: {
    UPDATE: "Error updating billing information.",
    FETCH: "Could not load billing profile.",
  },
  QR_CODES: {
    FETCH_DATA: "Failed to fetch QR code details.",
  },
  UNSUBSCRIBE: {
    ERROR: "Error during unsubscription.",
  },
  USERS: {
    FETCH: "Failed to load users.",
    CREATE: "Failed to create user.",
    UPDATE: "Failed to update user.",
    DELETE: "Failed to delete user.",
  },
  IMAGE_UPLOAD: {
    ERROR: "Failed to upload the image to the server.",
  },
  GENERAL: {
    DEFAULT: "An unexpected error occurred. Please try again.",
    NETWORK: "Network error. Please check your internet connection or CORS configuration.",
    TIMEOUT: "Request timeout. Please try again.",
  },
} as const;

export const INVALID_SET_PASSWORD_LINK_CODES = new Set([
  "user_email_not_found",
  "user_status_not_invited",
]);
